import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Chart, Legend, LineAdvance } from "bizcharts"

import ErrorBoundary from "../../../../../../components/ErrorBoundary"

function getTickInterval(granularity) {
  switch (granularity) {
    case "Hours":
      return 60 * 60 * 1000
    case "Days":
      return 24 * 60 * 60 * 1000
    case "Minutes":
      return 60 * 1000
    case "Seconds":
      return 1000
    default:
      return 24 * 60 * 60 * 1000
  }
}

function getMask(granularity) {
  switch (granularity) {
    case "Seconds":
      return "DD MMM HH:mm:ss"
    case "Minutes":
      return "DD MMM HH:mm"
    case "Hours":
      return "DD MMM HH:mm"
    case "Days":
      return "DD MMM"
    case "Months":
      return "MMM YYYY"
    case "Years":
      return "YYYY"
    default:
      return "DD MMM"
  }
}

const LineChartWithLegend = ({ graph, theme }) => {
  const legendColors = useMemo(() => {
    if (process.env.REACT_APP_GRAPH_COLOR) {
      return ["type", process.env.REACT_APP_GRAPH_COLOR.split(",")]
    } else {
      return ["type"]
    }
  }, [])

  const xAxisDetails = graph?.graphMetadata?.xAxisDetails || {}
  const mask = getMask(xAxisDetails.granularity)
  const tickInterval = getTickInterval(xAxisDetails.granularity)

  const scale = useMemo(() => {
    const base = { yAxisValue: { min: 0 } }
    if (graph?.graphMetadata?.xAxisDetails) {
      return {
        ...base,
        xAxisValue: {
          type: xAxisDetails.type || "time",
          tickInterval,
          mask,
          range: [0, 1],
        },
      }
    }
    return base
  }, [
    graph?.graphMetadata?.xAxisDetails,
    xAxisDetails.type,
    tickInterval,
    mask,
  ])

  return (
    <ErrorBoundary>
      <Chart
        theme={theme}
        data={graph?.graphData}
        padding={[40, 25, 40, 40]}
        height={350}
        scale={scale}
        animate={false}
        autoFit
      >
        <Legend position="top" />
        <LineAdvance
          shape={graph?.graphMetadata?.shape || "line"}
          position="xAxisValue*yAxisValue"
          color={legendColors}
        />
      </Chart>
    </ErrorBoundary>
  )
}

const mapStateToProps = state => ({
  theme: state.page_details.theme,
})

LineChartWithLegend.propTypes = {
  graphMetrics: PropTypes.array,
  graphData: PropTypes.array,
  loading: PropTypes.bool,
  loadError: PropTypes.bool,
  theme: PropTypes.string,
  title: PropTypes.string,
  handleRetry: PropTypes.func,
}

LineChartWithLegend.defaultProps = {
  graphMetrics: [],
  graphData: [],
  loading: false,
  loadError: false,
  title: "",
  handleRetry: () => {},
}

export default connect(mapStateToProps)(LineChartWithLegend)
